<template>
  <div>
    <vs-row>
      <vs-col>
        <vs-card class="cardx">
          <div slot="header" style="padding:10px">
            <h3>
              Drivers report
            </h3>
          </div>
          <div>
            <vs-row>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <div class="mb-3" style="width:300px;display:inline-block;margin-right:10px;">
                  <label class="vs-input--label">Driver</label>
                  <v-select
                    @input="filters.page=1"
                    v-model="filters.driver_id"
                    :clearable="true"
                    :options="drivers"
                    :reduce="el => el.id"
                    label="name"
                    :get-option-label="(option)=>{ return `${option.firstname} ${option.lastname}`}"
                  />
                </div>
                <div class="mb-3" style="display:inline-block;vertical-align:middle;">
                  <vs-dropdown class="mr-2 mt-2"  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>From</b>: {{since}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQuery" calendar-class="border-none" :inline="true" v-model="dates.since" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <vs-dropdown class="mr-2 "  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>To</b>: {{until}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQuery" calendar-class="border-none" :inline="true" v-model="dates.until" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

              </vs-col>
              <vs-col vs-lg="4" vs-sm="4" vs-xs="4" style="vertical-align:middle;">
                <div style="text-align: right; vertical-align:middle;">
                  <vs-button class="mr-3 mb-3" @click="download" color="primary" type="filled">Download</vs-button>
                </div>
              </vs-col>
            </vs-row>


            <div  v-if="report">
              <vs-table
                stripe
                :data="report.drivers">
                <template slot="thead">
                  <vs-th style="min-width: 120px;">
                    Date
                  </vs-th>
                  <vs-th>
                    Driver
                  </vs-th>
                  <vs-th>
                    Trips
                  </vs-th>
                  <vs-th>
                    Pending
                  </vs-th>
                  <vs-th>
                    Completed
                  </vs-th>
                  <vs-th>
                    Cancelled
                  </vs-th>
                  <vs-th>
                    In progress
                  </vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="'row'+index" v-for="(item,index) in data">
                    <vs-td >
                      {{item.date}}
                    </vs-td>
                    <vs-td>
                      <router-link
                        :to="{name:'partner.reports.drivers.detail.trips', params:{driver_id: item.id}}">
                        {{item.name}}
                      </router-link>
                    </vs-td>
                    <vs-td>
                      {{item.trips.total}}
                    </vs-td>
                    <vs-td>
                      {{item.trips.pending}}
                    </vs-td>
                    <vs-td>
                      {{item.trips.completed}}
                    </vs-td>
                    <vs-td>
                      {{item.trips.cancelled}}
                    </vs-td>
                    <vs-td>
                      {{item.trips.processing}}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <div class="mt-3 mb-3">
                 <span style="float:left;">
                  <vs-select
                    @input="filters.page=1"
                    class=""
                    label=""
                    v-model="filters.limit"
                    width="100px"
                    size="small"

                  >
                    <vs-select-item :key="'lim-'+index" :value="item.value" :text="item.text" v-for="(item,index) in limitOptions" />
                  </vs-select>
                </span>
                <pagination :last-page="report.pagination.pages" v-model="filters.page" />
              </div>
            </div>


          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker';
  import { CalendarIcon } from 'vue-feather-icons'
  const FileDownload = require('js-file-download');
  import limitOptions from "../../../constants/limit";

  export default {
    name: "Drivers",
    components: {
      Datepicker,
      CalendarIcon
    },
    data(){
      return {
        filters: {},
        dates : {
          page: 0,
          since: moment().subtract(1,'weeks').toDate(),
          until: moment().toDate()
        },
        report : null,
        page: 0,
        drivers: [],
        limitOptions
      }
    },
    computed : {
      since(){
        return moment(this.dates.since).format('YYYY-MM-DD');
      },
      until(){
        return moment(this.dates.until).format('YYYY-MM-DD');
      },
      ...mapState(['partner_namespace']),
    },
    watch : {
      filters : {
        deep: true,
        handler(newVal, oldVal){
          this.setRouteQuery();
          //if(!_.isEqual(newVal, oldVal))
          this.doSearch();
        }
      }
    },
    created() {
      if(this.$route.query.since){
        this.dates.since = moment(this.$route.query.since).toDate();
      }
      if(this.$route.query.until){
        this.dates.until = moment(this.$route.query.until).toDate();
      }
      this.filters = {
        limit: '20',
        ...this.$route.query,
        page: this.$route.query.page ? Number(this.$route.query.page) : 1,
        since: this.since,
        until : this.until,
      };
      this.fetchDrivers({limit: 1000, partner_id: this.partner_namespace}).then(data=>{
        this.drivers = _.cloneDeep(data.drivers);
      });
      this.doSearch = _.debounce(this.getItems,300);
    },
    methods : {
      ...mapActions('partners',['fetchDriversReport']),
      ...mapActions('drivers',['fetchDrivers']),
      setRouteQuery(){
        let query = {...this.filters, page: `${this.filters.page}`};
        if(!_.isEqual(query, this.$route.query)){
          try{
            this.$router.push({query});
          }catch(error){

          }
        }
      },
      updateDateQuery(){
        this.filters = {
          ...this.filters,
          page: 1,
          since: this.since,
          until : this.until,
        }
      },
      onChangePage(page){
        this.page = page;
        this.filters.page = `${page}`;
        //this.$router.push({query: {...this.$route.query, page}})
      },
      getItems(){
        this.$vs.loading({type:'point'});
        this.fetchDriversReport(this.filters)
          .then(response=>{
            this.report = response.data;
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })
      },
      download(){
        this.$vs.loading({type:'point'});
        this.fetchDriversReport({
          since: this.since,
          until : this.until,
          export: true,
          format: 'csv'
        })
          .then(response=>{
            FileDownload(response.data, `drivers-report-${this.since}-${this.until}.csv`);
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })
      }
    }
  }
</script>

<style scoped>

</style>
